<template>
	<div class="cloud-menu">
		<el-collapse v-model="activeNames" @change="handleChange">
			<!-- 山东省 - 带HTML格式标题 -->
			<el-collapse-item v-for="item in nationalTunnelList" :key="item.province">
				<template slot="title">
					<div class="province-title">
						<i class="el-icon-location"></i> {{ item.name }}
						<p class="count">{{ item.num }}条</p>
					</div>
				</template>
				<div class="tunnel-list">
					<ul style="list-style: none; margin: 0px; padding: 0px;">
						<li v-for="items in item.tunnelArry" :key="items.itemId" @click="handleClick(items)"
							style="cursor: pointer;">
							{{ items.name }}
						</li>
					</ul>
				</div>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>

import { getstatisticsTunnelCount } from '@/public/api.js'
import city from "@/utils/city.json";
import { ProvinceData } from "../testData/ProvinceData";

// 引入路由实例
export default {
	name: 'Province',
	components: {
		
	},
	data() {
		return {
			activeNames: ['1'],
			nationalTunnelList: []
		}
	},
	computed: {

	},
	mounted() {
		let that = this;
		let hostName = window.location.hostname;

		if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
			let tunnelCount = 0;
			let tunnelArry = [];
			let DepartmentListData = JSON.parse(localStorage.getItem('transferDepartmentListData'));

			ProvinceData().forEach(item => {
				city.forEach(itemCity => {
					if (itemCity.value === item.provinceId) {
						tunnelCount = 0;
						tunnelArry = [];

						DepartmentListData.forEach(itemDepartment => {
							itemDepartment.children.forEach(RowsDepartment => {
								if (RowsDepartment.proId === item.provinceId) {
									tunnelCount = item.count;
									tunnelArry.push({
										name: RowsDepartment.itemName,
										itemId: RowsDepartment.itemId,
										itemTunnelType: RowsDepartment.itemTunnelType,
									})
								}
							})
						})


						that.nationalTunnelList.push({
							name: itemCity.label,
							num: tunnelCount,
							provinceId: item.provinceId,
							tunnelArry: tunnelArry
						})
					}
				})

			})
		} else {
			this.StatisticsTunnelCount();
		}

	},
	methods: {
		// 统计隧道数量
		StatisticsTunnelCount() {
			this.refreshKey += 1;
			let that = this;
			getstatisticsTunnelCount({}).then(res => {
				if (res.data.code == 200) {
					let dataDom = res.data.data;
					let tunnelCount = 0;
					let tunnelArry = [];
					let DepartmentListData = JSON.parse(localStorage.getItem('transferDepartmentListData'));

					dataDom.forEach(item => {
						city.forEach(itemCity => {
							if (itemCity.value === item.provinceId) {
								tunnelCount = 0;
								tunnelArry = [];

								DepartmentListData.forEach(itemDepartment => {
									itemDepartment.children.forEach(RowsDepartment => {
										if (RowsDepartment.proId === item.provinceId) {
											tunnelCount += 1;
											tunnelArry.push({
												name: RowsDepartment.itemName,
												itemId: RowsDepartment.itemId,
												itemTunnelType: RowsDepartment.itemTunnelType,
											})
										}
									})
								})


								that.nationalTunnelList.push({
									name: itemCity.label,
									num: tunnelCount,
									provinceId: item.provinceId,
									tunnelArry: tunnelArry
								})
							}
						})

					})
				}
			})
		},
		handleChange(names) {
			this.activeNames = names;
		},
		// 点击隧道项处理
		handleClick(items) {
			JSON.parse(localStorage.getItem('transferDepartmentListData')).forEach(item => {
				item.children.forEach(RowsDepartment => {
					if (RowsDepartment.itemId === items.itemId) {
						localStorage.setItem('updateLhTunnels', JSON.stringify({
							planBeginDate: RowsDepartment.planBeginDate || '-',
							planCompleteDate: RowsDepartment.planCompleteDate || '-',
							itemName: RowsDepartment.itemName || '-',
							status: RowsDepartment.status || '-',
							itemAddr: RowsDepartment.itemAddr || '-',
							itemId: RowsDepartment.itemId || '-',
							type: RowsDepartment.type || '-',
							itemTunnelType: RowsDepartment.itemTunnelType || '-',
						}));
						this.$router.push({
							path: '/detailDetach',
							// query: {
							// 	tunnelId: item.itemId,
							// 	tunnelName: item.name
							// }
						});
					}
				})
			})
		},
	},
	beforeDestroy() {

	}
}
</script>
<style scoped>
.cloud-menu {
	width: 100%;
	height: 100%;
	text-align: left;


	::v-deep .province-title {
		width: 90%;
		height: 25px;
		line-height: 25px;
		margin: 0px;
		padding: 0px;
	}

	/* 数量统计样式 */
	::v-deep .count {
		width: 100px;
		height: 20px;
		font-size: 12px;
		color: #909399;
		margin: 0px;
		padding: 0px;
		float: right;
		text-align: right;
	}


}


/* 1. 核心优化：cloud-menu容器的滚动条宽度减小到2px */
::v-deep .cloud-menu::-webkit-scrollbar {
	width: 2px;
	/* 垂直滚动条宽度（核心调整） */
	height: 2px;
	/* 水平滚动条宽度 */
}

/* 2. 滚动条轨道 - 透明化处理，减少视觉干扰 */
::v-deep .cloud-menu::-webkit-scrollbar-track {
	background: transparent;
	/* 完全透明的轨道 */
}

/* 3. 滚动条滑块 - 纤细且半透明 */
::v-deep .cloud-menu::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.2);
	/* 半透明黑色滑块 */
	border-radius: 1px;
	/* 极细圆角，与2px宽度匹配 */
	transition: background 0.2s ease;
}

/* 4. 滑块悬停效果 - 增强交互感知 */
::v-deep .cloud-menu::-webkit-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, 0.35);
	/* 悬停时加深颜色 */
}

/* 5. 滚动条角落（水平+垂直交汇区）隐藏 */
::v-deep .cloud-menu::-webkit-scrollbar-corner {
	background: transparent;
}


/* 深度选择器，穿透 scoped 限制 */
.cloud-menu ::v-deep .el-collapse-item__header {
	background-color: transparent !important;
	color: rgb(163, 162, 162);
	border-radius: 0px 0px 0px 0px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.12);
	height: 35px;
	line-height: 35px;
	/* 可以添加文字颜色，避免深色背景看不见文字 */
}

/* 可选：修改内容区域样式 */
.cloud-menu ::v-deep .el-collapse-item__content {
	background-color: transparent !important;
	color: #ccc;
	text-indent: 10px;
	padding: 5px;
}

.cloud-menu ::v-deep .el-collapse-item__wrap {
	background-color: transparent !important;
	color: #ccc;
}

.cloud-menu ::v-deep .el-collapse {
	border-top: 0px solid #222324;
	border-bottom: 1px solid #141414;
}
</style>